<template>
<div class="popup" v-cloak v-show="deleteAccountShow">
    <div class="content" id="deleteAccount" :style="{height:getHeight()}">
        <div class="title">
            {{$t('language.popup.personalCenter.deleteAccount')}}
            <div class="icon white-close dialog-close" @click="closePage()"></div>
        </div>
        <div class="delete-Account-content">
            <input v-if="!user.loginType||user.loginType=='sub'||(isActiveLoginType(user.loginType))" class="delete-Account-input" type="password" :placeholder="$t('language.popup.personalCenter.enterPassWord')" v-model="password" />
            <div class="advise-box">
                <textarea v-model="note" :placeholder="$t('language.popup.personalCenter.note')">
               </textarea>
            </div>
            <button class="done-button" @click="deleteDone()">{{$t('language.common.done')}}</button>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
export default {
    data: function () {
        return {
            deleteAccountShow: false,
            password: '',
            sureDeleShow: false,
            unsubscribeShow: false,
            note: '',
            user:commonUtils.getUser()
        }
    },
    methods: {
        isActiveLoginType(type){
            return commonstate.activeLoginTypeList.includes(type)||commonstate.channelTypeList.includes(type)||type.indexOf("YouTube:")>-1;
        },
        getHeight(){
         let height=360+'Px';
         if(this.user&&this.user.loginType&&(commonstate.thirdLoginList.includes(this.user.loginType))){
             height=320+'Px';
         }
         return height;
        },
        deleteDone() {
            let user= commonUtils.getUser();
            if (!user || !user.id) {
             this.$router.push('/turnLoginPage');
            }
            //如果用户未输密码并且不是第三方登录
            if (!this.password && (!user.loginType||!(commonstate.thirdLoginList.includes(user.loginType)))) {
                this.$toast({
                    text: this.$t('language.login.enterVaildPassWord'),
                    type: 'fail',
                    idValue: "deleteAccount"
                });
                return false;
            }
            if (user.vip) {
                //若新版支付系统上线
                if (user.payStatus == 'Completed') {
                    if((user.subscrId.substr(0,2) == "20" || user.subscrId.substr(0,1) == "3")){
                        //如果是苹果订阅用户
                        var that = this;
                        //获取当前订阅信息
                        this.Utils.doSubscriptionPostRequest('get_by_user', { ud: user.id }).then(res => {
                            //如果请求成功
                            if (res.message == 'Success' && res.vipSchemes) {
                                var nowScheme = res.nowScheme;
                                that.$parent.$refs.iosPayTipDialog.iosPayTipShow = true;
                                that.$parent.$refs.iosPayTipDialog.payInfo = {
                                    name: nowScheme.name,
                                    appleId: user.subscrId,
                                };
                            }
                            that.deleteAccountShow=false;
                            //缓存信息
                            that.$store.commit("setPaySysRes", res);
                        });
                        return false;
                    }else if(user.subscrId.substr(0,4) == "GPA."){
                    	//如果是googlePLay用户 可以直接删除，通过后端退订
                        this.$parent.$refs.deleteAccountRemindDialog.unsubscribeShow = false;
                        this.$parent.$refs.deleteAccountRemindDialog.payVip = false;
                    }else{
                        this.$parent.$refs.deleteAccountRemindDialog.payVip = true;
                    }
                } else {
                    this.$parent.$refs.deleteAccountRemindDialog.unsubscribeShow = false;
                    this.$parent.$refs.deleteAccountRemindDialog.payVip = false;
                }
                this.deleteAccountShow=false;
                this.$parent.$refs.deleteAccountRemindDialog.deleteRemindShow = true;
                return false;
            }
            this.deleteAccountRequest();
        },
        deleteAccountRequest() {
            let that = this;
            let user = commonUtils.getUser();
            let deleteUser = {
                ud: user.id,
                password: this.password.trim(),
                delReson: this.note
            }
            //如果用户是第三方登录
            if(user.loginType&&(commonstate.thirdLoginList.includes(user.loginType))){
               deleteUser = {
                ud: user.id,
                password: user.salt,
                delReson: this.note
               }
            }
            this.Utils.doUserHaveLoginRequest('delete', deleteUser).then(res => {
                if (res.status == 200) {
                    this.deleteAccountShow=false;
                    that.$store.commit('setleftbannerClick', -1);
                    that.$store.commit('setleftbannerMenuClick', 6);
                    let language = commonUtils.caseIndexLanguage(localStorage.getItem("locale"));
                    window.location.href = commonstate.oldVersionUrl + "/action/userinfo!exitLogin?redirect=" + commonstate.frontEndUrl + (language=="en"?"":"/"+language) + "";
                    that.$store.commit("setUsersDrives", []);
                    localStorage.removeItem(user.id+"interimPsd");
                    commonUtils.logout_clear();
                } else {
                    if(res.reason=='saltInvalid'){
                        that.$router.push('/turnLoginPage');
                        return;
                    }
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "leftBan"
                    });
                }
            });
        },
        closePage(){
            this.deleteAccountShow=false;
            this.password=null;
        }
    },

}
</script>

<style>
#deleteAccount {
    width: 500px;
    /*no*/
}

.delete-Account-content {
    width: 100%;
    height: 320px;
    /*no*/
    box-sizing: border-box;
    padding: 20px;
    /*no*/
}

.advise-box {
    width: 100%;
    height: 160px;
    /*no*/
    margin-top: 20px;
    /*no*/
}

.advise-box textarea {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid #E0EAF9;
    /*no*/
    padding: 10px;
    /*no*/
    font-size: 14px;
    /*no*/
    line-height: 20px;
    /*no*/
    font-family: Arial, "Microsoft YaHei", 微软雅黑;
    resize: none;
    color: #6f7886;
}

.advise-box textarea::-webkit-input-placeholder {
    color: #ccc;
}

.advise-box textarea:focus {
    border: 1px solid #8a96e3;
    /*no*/
    outline: none;
}

.done-button {
    float: right;
    margin-top: 25px;
    /*no*/
}

.sureDeleAccount {
    width: 500px;
    /*no*/
    height: 200px;
    /*no*/
}

.sure-dele-content {
    width: 100%;
    height: 160px;
    /*no*/
    text-align: center;
    color: #6f7886;
    position: relative;
    box-sizing: border-box;
    padding-top: 40px;
    /*no*/
    font-size: 14px;
    /*no*/
}

.button-line {
    width: 100%;
    margin-top: 30px;
    /*no*/
}

.yes-dele,
.no-dele {
    background: #fff;
    color: #5065bb;
    border: 1px solid #b3bcf6;
    /*no*/
}

.yes-dele {
    margin-left: 40px;
    /*no*/
}

.yes-dele:hover,
.no-dele:hover {
    background: #5065bb;
    color: #fff;
    border: none;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/delete_account_popup.vue